import React from "react";
import { withTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { ReactComponent as DeleteOutlinedIcon } from "./delete-outlined.svg";

function DeleteDialog({ isOpen, onDismiss, onDelete, t }) {
  return (
    <Dialog
      zIndex={200}
      type="warning"
      icon={DeleteOutlinedIcon}
      isOpen={isOpen}
      heading={t("scheduler.deleteDialog.heading")}
      buttons={[
        {
          text: t("buttons.cancel"),
          onClick: onDismiss
        },
        {
          text: t("buttons.delete"),
          onClick: onDelete
        }
      ]}
    />
  );
}

export default withTranslation()(DeleteDialog);
